import {useEffect, useState} from "react";
import ApiRoute, {shopId} from "../../../helper/api";
import Layout from "../../Layout";
import SearchBox from "../../SearchBox";
import FilterInventory from "../FilterInventory";
import {formatNumberWithDots} from "../../../helper/general";
import InventoryFilterStateTab from "../InventoryFilterStateTab";
import InventoryTable from "../../Tables/InventoryTable";
import Pagination from "../../Pagination";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import {useLocation, useNavigate} from "react-router-dom";

export default function PrimaryInventoryList(){
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const location = useLocation();
    const navigate = useNavigate();

    const [showFilterBox, setShowFilterBox] = useState(true)
    const [isLoading, setIsLoading] = useState(true)
    const [updateData, setUpdateData] = useState('0')
    const [pageNumber, setPageNumber] = useState(parseInt(params.get('page') || '1'))
    const [data, setData] = useState({})
    const [searchQuery, setSearchQuery] = useState({
        term: params.get('term') || '',
        by: params.get('by') || 'title'
    })
    const [filterQuery, setFilterQuery] = useState(() => {
        // بازیابی فیلترها از URL
        try {
            return params.get('filters') ? JSON.parse(decodeURIComponent(params.get('filters'))) : {};
        } catch (e) {
            return {};
        }
    })

    // state tab for filtering
    const [statsTab , setStatsTab] = useState(null)
    const [selectedStatsTab , setSelectedStatsTab] = useState(params.get('status') || '')
    const [id , setId] = useState(params.get('id') ?? '')

    // ذخیره وضعیت فیلترها در URL
    useEffect(() => {
        const currentParams = new URLSearchParams(location.search);
        
        // ذخیره فیلترها در URL
        if (Object.keys(filterQuery).length > 0) {
            console.log(filterQuery)
            currentParams.set('filters', encodeURIComponent(JSON.stringify(filterQuery)));
        } else {
            currentParams.delete('filters');
        }
        
        // ذخیره جستجو در URL
        if (searchQuery.term) {
            currentParams.set('term', searchQuery.term);
            currentParams.set('by', searchQuery.by);
        } else {
            currentParams.delete('term');
            currentParams.delete('by');
        }
        
        // ذخیره شماره صفحه در URL
        currentParams.set('page', pageNumber.toString());
        
        // ذخیره وضعیت تب در URL
        if (selectedStatsTab) {
            currentParams.set('status', selectedStatsTab);
        } else {
            currentParams.delete('status');
        }
        
        // حفظ پارامتر id اگر وجود داشته باشد
        if (id) {
            currentParams.set('id', id);
        } else {
            currentParams.delete('id');
        }
        
        // به‌روزرسانی URL بدون ریفرش صفحه
        navigate('?' + currentParams.toString(), { replace: true });
    }, [filterQuery, searchQuery, pageNumber, selectedStatsTab, id]);

    //fetch data from server and update data /| based on updateData state
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            const  res  = await ApiRoute.product.inventory.index.fn({
                shop_id: shopId(),
                state:selectedStatsTab,
                id:id,
                page : pageNumber
            },filterQuery)
            setData(res)
            setIsLoading(false)
        })();
    }, [updateData]);

    // watch searchQuery and update updateData state
    useEffect(() => {
        // ایجاد یک نسخه جدید از filterQuery با استفاده از spread operator
        const newFilterQuery = { ...filterQuery };
        newFilterQuery.quick_search = searchQuery;
        setFilterQuery(newFilterQuery);
        setPageNumber(1);
        setUpdateData(Date.now().toString());
    }, [searchQuery]);

    //fetch stats-data from server
    useEffect(() => {
        (async () => {
            const  res  = await ApiRoute.product.inventory.stats.fn({
                shop_id: shopId(),
            },filterQuery)
            setStatsTab(res.results)
        })();
    }, [data]);

    // watch filterQuery and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [filterQuery]);

    // watch statsTab and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [selectedStatsTab]);

    // watch pageNumber and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [pageNumber]);


    const paginationData = data?.results
    const tableData = data?.results?.data ?? []

    return (
        <div>
            <div>
                <div className="page-title mb-3"><span className="inline-block bg-white pl-3">انبارداری</span></div>
                <div className="flex gap-3">
                    <SearchBox 
                        SearchByOptions={[
                            { label: "نام محصول" , value : "title" },
                            { label: "کد آسان" , value : "asan_id" }
                        ]} 
                        SearchIn={true} 
                        SetSearchQuery={setSearchQuery} 
                        SearchByDefault={`title`}
                        initialSearchTerm={searchQuery.term}
                    />
                </div>
                <FilterInventory filterQuery={filterQuery} SetFilterQuery={(s) => {
                    // ایجاد یک نسخه جدید برای جلوگیری از تغییر مستقیم
                    setFilterQuery({...s});
                    setUpdateData(Date.now().toString());
                }} showHide={showFilterBox}/>

                { id?.length > 0 && <div className={`purple-2-tag flex items-center gap-3 rounded w-auto !max-w-max`}>
                    <span>محصول به شناسه : {id}</span>
                    <FontAwesomeIcon onClick={() => {
                        setId("");
                        const currentParams = new URLSearchParams(location.search);
                        currentParams.delete('id');
                        navigate('?' + currentParams.toString(), { replace: true });
                    }} className={`text-white cursor-pointer bg-red-1 px-2 py-2 rounded`} icon={faTimes}/>
                </div>}

                <p className="text-left lg:pl-2 text-xs text-gray-5 pt-6 lg:pt-0">شما {formatNumberWithDots(paginationData?.total)} تعداد محصول ثبت شده دارید</p>
                    <div className="main-content p-1 mt-2">
                    <InventoryFilterStateTab
                        selectedTab={selectedStatsTab}
                        setSelectedTab={setSelectedStatsTab}
                        options={statsTab}
                    />
                    
                    {isLoading ? (
                        <div className="flex justify-center items-center py-10">
                            <FontAwesomeIcon icon={faSpinner} spin className="text-3xl text-purple-600" />
                        </div>
                    ) : (
                        <InventoryTable
                            onSort={ (name , dir) => {
                                // ایجاد یک نسخه جدید از فیلترها با spread operator
                                const newFilterQuery = { ...filterQuery };
                                // مقداردهی آرایه به صورت جدید
                                newFilterQuery.auto_sort = [
                                    {
                                        name: name,
                                        value: dir
                                    }
                                ];
                                // اعمال تغییرات به state اصلی
                                setFilterQuery(newFilterQuery);
                                setUpdateData(Date.now().toString());
                            } }
                            setUpdateData={setUpdateData}
                            tableData={tableData}/>
                    )}
                    <Pagination SetPageNumber={setPageNumber} Data={paginationData}/>
                </div>
            </div>
        </div>
    )
}